module.exports = __webpack_public_path__ + "img/hover-iocn3.62a020bb.svg";